export default __webpack_public_path__ + "img/moon-cloud-storm.4ea5b73.svg";